
import React, { useEffect, useRef, useState } from 'react';
import TakeLookTopSection from '../../../components/TakeALook/TakeLookTopSection';
import TakeLookSubHeading from '../../../components/TakeALook/TakeLookSubHeading';


import InstagramLogo from '../../../assets/img/customer-service-center/Instagram.png';
import FacebookLogo from '../../../assets/img/customer-service-center/Facebook.png';
import KakaoLogo from '../../../assets/img/customer-service-center/Kakao.png';

// Kakao JS Key
// const KAKAO_KEY = '14be42c9a3c3c7f2f24153d25810ba11';
const KAKAO_KEY = 'a13a559fb1f5b864d81b8a4a48c07c0c';

// Helper: absolute image URL
const getAbsoluteUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return path.startsWith('/') ? `${origin}${path}` : `${origin}/${path}`;
};

const TakeLookPCFamilyHall = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const shareDesktopRef = useRef(null);
  const shareMobileRef = useRef(null);


  const images = [
    { main: '/images/TakeLook/04_Familly/가족묘_01.jpg', thumbnail: '/images/TakeLook/04_Familly/가족묘_01.jpg' },
    { main: '/images/TakeLook/04_Familly/가족묘_02.jpg', thumbnail: '/images/TakeLook/04_Familly/가족묘_02.jpg' },
    { main: '/images/TakeLook/04_Familly/가족묘_03.jpg', thumbnail: '/images/TakeLook/04_Familly/가족묘_03.jpg' },
    { main: '/images/TakeLook/04_Familly/가족묘_04.jpg', thumbnail: '/images/TakeLook/04_Familly/가족묘_04.jpg' },
    { main: '/images/TakeLook/04_Familly/가족묘_05.jpg', thumbnail: '/images/TakeLook/04_Familly/가족묘_05.jpg' }
  ];

  // Init Kakao
  useEffect(() => {
    if (typeof window !== 'undefined' && window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_KEY);
      }
      return;
    }
    if (!document.getElementById('kakao-sdk')) {
      const script = document.createElement('script');
      script.id = 'kakao-sdk';
      script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
      script.async = true;
      script.onload = () => {
        if (window.Kakao && !window.Kakao.isInitialized()) {
          window.Kakao.init(KAKAO_KEY);
        }
      };
      document.body.appendChild(script);
    }
  }, []);

  
  useEffect(() => {
    const onClickOutside = (e) => {
      const d = shareDesktopRef.current;
      const m = shareMobileRef.current;
      if (d && d.contains(e.target)) return;
      if (m && m.contains(e.target)) return;
      setIsShareOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setIsShareOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

 
  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };
  const handleThumbnailClick = (index) => setCurrentImageIndex(index);

  
  const toggleShare = () => setIsShareOpen((v) => !v);

  const handleShareClick = (platform) => {
    const currentUrl = window.location.href;

    if (platform === 'facebook') {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
        '_blank',
        'width=600,height=500'
      );
    }

    if (platform === 'instagram') {
      window.open('https://www.instagram.com/', '_blank', 'width=1200,height=800');
    }

    if (platform === 'kakao') {
      const imageUrl = getAbsoluteUrl(images[currentImageIndex].main);

      const tryFallback = () => {
        window.open(
          `https://story.kakao.com/share?url=${encodeURIComponent(currentUrl)}`,
          '_blank',
          'width=600,height=600'
        );
      };

      try {
        if (window.Kakao && window.Kakao.isInitialized()) {
          window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title: document.title || 'Take a Look',
              description: '가족묘 공유하기',
              imageUrl,
              link: {
                mobileWebUrl: currentUrl,
                webUrl: currentUrl,
              },
            },
            buttons: [
              {
                title: '웹에서 보기',
                link: { mobileWebUrl: currentUrl, webUrl: currentUrl },
              },
            ],
          });
        } else {
          tryFallback();
        }
      } catch (e) {
        tryFallback();
      }
    }

    setIsShareOpen(false);
  };

  return (
    <div className="announcement-list-page take-look-info-page sky-hall-vip-page">
      <TakeLookTopSection />
      <main className="main-content">
        <TakeLookSubHeading heading="가족묘" />

        <div className="take-look-page-content">
          <div className="full-view-content">
            {/* Gallery (Desktop) */}
            <div className="sky-hall-special-room-gallery">
              <div className="sky-hall-special-room-gallery-main-view">
                <img
                  src={images[currentImageIndex].main}
                  alt="가족묘 큰 이미지"
                  className="sky-hall-special-room-main-image"
                />
                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-prev"
                  onClick={handlePrevious}
                >
                  <img src="/images/Main/arrow-right-white.png" alt="Previous" />
                </button>
                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-next"
                  onClick={handleNext}
                >
                  <img src="/images/Main/arrow-left-white.png" alt="Next" />
                </button>
              </div>

              <div className="sky-hall-special-room-gallery-thumbnails-container">
                <div className="sky-hall-special-room-gallery-thumbnails">
                  {images.map((image, index) => (
                    <a
                      key={index}
                      href="#"
                      className={`sky-hall-special-room-thumbnail-item ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleThumbnailClick(index);
                      }}
                    >
                      <img src={image.thumbnail} alt={`Thumbnail ${index + 1}`} />
                    </a>
                  ))}
                </div>

                {/* Desktop Share */}
                <div className="full-view-share-section" ref={shareDesktopRef}>
                  <div className="share-container">
                    <button
                      className="full-view-share-button"
                      aria-haspopup="true"
                      aria-expanded={isShareOpen}
                      onClick={toggleShare}
                    >
                       <span className="share-text">SNS 공유</span>
                      <img src="/images/TakeLook/share.png" alt="공유" className="logo"/>
                    </button>

                    {isShareOpen && (
                      <div className="share-popup">
                        <div className="popup-title">공유하기</div>
                        <div className="popup-buttons">
                          <button onClick={() => handleShareClick('instagram')}>
                            <img src={InstagramLogo} alt="Instagram" />
                          </button>
                          <button onClick={() => handleShareClick('facebook')}>
                            <img src={FacebookLogo} alt="Facebook" />
                          </button>
                          <button onClick={() => handleShareClick('kakao')}>
                            <img src={KakaoLogo} alt="Kakao" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile View */}
            <div className="mobile-take-look-main-container">
              <div className="mobile-take-look-main-image-wrapper">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.main}
                      alt={`Family Hall ${index + 1}`}
                      className="mobile-take-look-main-image"
                      style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                    />
                  ))}
                </div>
              </div>

              {/* Mobile Share */}
              <div className="mobile-take-look-share-section" ref={shareMobileRef}>
                <div className="share-container">
                  <button
                    className="mobile-take-look-main-share-btn"
                    onClick={toggleShare}
                  >
                     <span className="share-text">SNS 공유</span>
                    {/* <img src="/images/TakeLook/share-mo.png" alt="공유" /> */}
                    <img src="/images/TakeLook/share.png" alt="공유" className="logo"/>
                  </button>

                  {isShareOpen && (
                    <div className="share-popup">
                      <div className="popup-title">공유하기</div>
                      <div className="popup-buttons">
                        <button onClick={() => handleShareClick('instagram')}>
                          <img src={InstagramLogo} alt="Instagram" />
                        </button>
                        <button onClick={() => handleShareClick('facebook')}>
                          <img src={FacebookLogo} alt="Facebook" />
                        </button>
                        <button onClick={() => handleShareClick('kakao')}>
                          <img src={KakaoLogo} alt="Kakao" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default TakeLookPCFamilyHall;
